import { DeploymentPage } from '@/pages/publish'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/publish/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <DeploymentPage />
}
